import { render, staticRenderFns } from "./tags.vue?vue&type=template&id=9e35c578&"
import script from "./tags.vue?vue&type=script&lang=ts&"
export * from "./tags.vue?vue&type=script&lang=ts&"
import style0 from "./tags.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports